export function getView(status, current_user_id, created_by_id) {
  return status === 'pending' && current_user_id !== created_by_id
}
